/**
 * PriorAuthProcessSection - Output section for prior authorization process
 *
 * Displays submission methods, contact information, and requirements.
 */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import React from 'react';

import { FieldPathProvider } from '../context';
import { Field, SectionTriggerScore } from './Field';

interface PriorAuthProcessSectionProps {
  data?: Record<string, unknown>;
  sectionId: string;
  entityType?: 'drug' | 'procedure';
}

export const PriorAuthProcessSection: React.FC<PriorAuthProcessSectionProps> = ({
  data,
  sectionId,
  entityType = 'drug',
}) => {
  const label = entityType === 'drug' ? 'Drug' : 'Procedure';

  return (
    <AccordionItem value={sectionId} className="border-b">
      <AccordionTrigger className="px-4 py-3 text-sm font-medium hover:bg-muted/50">
        <div className="flex items-center gap-2 flex-1">
          <span>{label} Prior Auth Process</span>
          <SectionTriggerScore subsectionKey="prior_auth_process" />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        <FieldPathProvider prefix={`${entityType}.prior_auth_process`}>
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <Field
              label="Department Name"
              value={data?.prior_authorization_department_name}
              fieldId="prior_authorization_department_name"
            />
            <Field
              label="Turnaround Time"
              value={data?.prior_authorization_turnaround_time}
              fieldId="prior_authorization_turnaround_time"
            />
            <Field
              label="Fax Number"
              value={data?.prior_authorization_fax_number}
              fieldId="prior_authorization_fax_number"
            />
            <Field
              label="Phone Number"
              value={data?.prior_authorization_phone_number}
              fieldId="prior_authorization_phone_number"
            />
            <Field
              label="Website"
              value={data?.prior_authorization_website}
              fieldId="prior_authorization_website"
            />
            <Field
              label="Submission Methods"
              value={data?.prior_authorization_submission_methods}
              fieldId="prior_authorization_submission_methods"
            />
            <Field
              label="Notification Methods"
              value={data?.prior_authorization_notification_methods}
              fieldId="prior_authorization_notification_methods"
            />
            <Field
              label="Requirements"
              value={data?.prior_authorization_requirements}
              fieldId="prior_authorization_requirements"
            />
          </div>
        </FieldPathProvider>
      </AccordionContent>
    </AccordionItem>
  );
};
